export enum HomeFundamentalsCardType {
    PRODUCT_IDEAS_LAB = 'Product Ideas Lab',
    RELEASE_NOTES = 'Release notes',
    ROADMAPS = 'Roadmaps',
    STATUS = 'Status',
}
